module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_bg_m-e64893306f4bf33a5035de7fc0ab5a5a.jpg";